module.exports = __webpack_public_path__ + "static/img/support_4.0996c24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/support_4.png
// module id = 4Z8c
// module chunks = 0